module.exports = __webpack_public_path__ + "img/text.cfaf63e7.png";